module.exports = __webpack_public_path__ + "static/media/ethereum.31e1aba0.webp";